import ReactDOM from 'react-dom'

import { MenuPlacement } from 'react-select/dist/declarations/src/types'
import TooltipSelect from './TooltipSelect'
import * as tooltipSelectSelectors from './tooltip-select.selector'

const TooltipSelectComponent = (() => {
	const init = () => {
		const target = tooltipSelectSelectors.getTarget()

		if (!target) return

		const getDataHandler = target.dataset.tooltipSelectGetDataHandler
		const menuPlacement = (target.dataset.tooltipSelectMenuPlacement as MenuPlacement) ?? 'top'
		const placeholder = target.dataset.tooltipSelectPlaceholder ?? ''

		if (!getDataHandler) return

		ReactDOM.render(
			<TooltipSelect getDataHandler={getDataHandler} menuPlacement={menuPlacement} placeholder={placeholder} />,
			target,
		)
	}

	return {
		init,
	}
})()

export default TooltipSelectComponent
